import React from 'react';
import { connect } from 'react-redux';
import { selectHeaderState } from '../../store/slice';
import { RootState } from '../../../../app/store';

import { AccountName, AccountDropdownButton } from './styles';

interface EmptyAccountDropdownProps {
  currentAccountName?: string;
}

const EmptyAccountDropdown: React.VFC<EmptyAccountDropdownProps> = ({
  currentAccountName,
}) => {
  return (
    <>
      <AccountDropdownButton data-ccx-e2e-id="aac-account-dropdown">
        <AccountName>{currentAccountName}</AccountName>
      </AccountDropdownButton>
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    currentAccountName:
      selectHeaderState(state).currentAccountInfo?.currentAccountName,
  };
};

export default connect(mapStateToProps)(EmptyAccountDropdown);
